var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 10.2961H8.99V15.2961C8.99 15.8461 9.44 16.2961 9.99 16.2961H13.99C14.54 16.2961 14.99 15.8461 14.99 15.2961V10.2961H16.58C17.47 10.2961 17.92 9.21611 17.29 8.58611L12.7 3.99611C12.31 3.60611 11.68 3.60611 11.29 3.99611L6.7 8.58611C6.07 9.21611 6.51 10.2961 7.4 10.2961ZM5 19.2961C5 19.8461 5.45 20.2961 6 20.2961H18C18.55 20.2961 19 19.8461 19 19.2961C19 18.7461 18.55 18.2961 18 18.2961H6C5.45 18.2961 5 18.7461 5 19.2961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.31ab6c2c3ba6182c727a735704419241.svg";
export { ForwardRef as ReactComponent };